import { useAuth } from "@/contexts/auth-context";

export default function HomePage() {
  const { user, logout } = useAuth();

  return (
    <div className="flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold tracking-tight">
          AI Agent Marketplace
        </h1>
        <p className="mt-4 text-lg text-muted-foreground">
          Discover and deploy AI agents for your business
        </p>
        {user && (
          <p className="mt-2 text-sm text-content-medium">{user.email}</p>
        )}
        <button
          onClick={logout}
          className="mt-6 h-10 px-6 rounded-full border border-black/15 text-sm font-bold text-content-strong hover:bg-black/[0.04] transition-colors"
        >
          로그아웃
        </button>
      </div>
    </div>
  );
}
